import { ArrowLeftCircle } from "iconoir-react";
import React from "react";
import { useNavigate } from "react-router-dom";

const NotFoundPage = () => {
    const navigate = useNavigate();
    return (
        <div className="px-5 pt-6 pb-14">
            <div className="flex items-center justify-between">
                <ArrowLeftCircle
                    onClick={() => {
                        navigate(-1);
                    }}
                />
                <div className="ml-[22px] text-[#28353B] font-bold text-[28px] leading-[29px]"></div>
            </div>
        </div>
    );                                                                                          
};

export default NotFoundPage;
